<template>
  <div class="page-container">
    <h1 class="page-title">{{ $t("myOffice") }}</h1>
    <div style="margin-top: 18px">
      <div class="tab-switcher-container">
        <span
          v-for="(tab, index) in tabs"
          :key="index"
          :class="['tab-switcher', { active: activeTab === index }]"
          @click="changeTab(index)"
        >
          {{ $t(tab) }}
        </span>
      </div>
      <div class="table-container" v-if="activeTab === 0">
        <div v-if="permessions.OFFICE_PRODUCT_CREATE" class="actions_container">
          <router-link to="/my-office/product/add">
            <button class="add_product_btn mb-3">
              {{ $t("addProduct") }}
            </button>
          </router-link>
        </div>
        <div>
          <table-with-filter
            style="width: 100%"
            :is-filterable="false"
            fixed-header
            :height="$vuetify.breakpoint.height - 160"
            hide-default-footer
            :headers="headers"
            :items="items"
          >
            <template #item.createdAt="{ item }">
              <span>{{ fullTimeParse(item.createdAt) }}</span>
            </template>
            <template #item.generated="{ item }">
              <span class="badge" :class="{ badgeSuccess: item.generated }">{{
                item.generated ? $t("available") : $t("no")
              }}</span>
            </template>
            <template #item.ownerName="{ item }">
              <span>{{ item.ownerName ? item.ownerName : $t("no") }} </span>
            </template>
            <template #item.type="{ item }">
              <span>{{
                item.type === "FOR_USE" ? $t("foruse") : $t("forrealization")
              }}</span>
            </template>
            <template #item.actions="{ item }">
              <div>
                <v-btn
                  v-if="permessions.OFFICE_PRODUCT_READ"
                  :to="`/my-office/product/view/${item.id}`"
                  class="new_style"
                >
                  <vue-icon icon="newEyeIcon"></vue-icon>
                </v-btn>
                <v-btn
                  v-if="permessions.OFFICE_PRODUCT_UPDATE"
                  :to="`/my-office/product/edit/${item.id}`"
                  class="new_style"
                >
                  <vue-icon icon="newPencilIcon"></vue-icon>
                </v-btn>
                <v-btn
                  v-if="
                    permessions.OFFICE_PRODUCT_ITEM_READ &&
                    item.type === 'FOR_USE'
                  "
                  :to="`/my-office/product/${item.id}`"
                  class="new_style"
                >
                  <vue-icon icon="newTimeIcon"></vue-icon>
                </v-btn>
                <v-btn
                  v-if="permessions.OFFICE_PRODUCT_DELETE"
                  class="new_style"
                  @click="$refs.deleteProductConfirmDialogRef.open(item)"
                >
                  <vue-icon icon="newTrashIcon"></vue-icon>
                </v-btn>
              </div>
            </template>
          </table-with-filter>
          <VuePagination
            go-to
            @update:limit="
              (limit) => {
                configuration.limit = limit;
                configuration.page = 1;
                changePage();
              }
            "
            v-model="configuration.page"
            :length="lastPage"
            @input="changePage"
            :limit="configuration.limit"
          />
        </div>
      </div>
      <div class="table-container" v-if="activeTab === 1">
        <div class="actions_container">
          <button
            v-if="permissionsDepartment.DEPARTMENT_CREATE"
            class="add_product_btn mb-3"
            @click="openCreateDepartmentDialog"
          >
            {{ this.$t("addDepartment") }}
          </button>
        </div>
        <div>
          <table-with-filter
            style="width: 100%"
            :is-filterable="false"
            fixed-header
            :height="$vuetify.breakpoint.height - 160"
            hide-default-footer
            :headers="headerDepartment"
            :items="departmentItems"
          >
            <template #item.createdAt="{ item }">
              <span>{{ fullTimeParse(item.createdAt) }}</span>
            </template>

            <template #item.productCount="{ item }">
              <span>{{ Number(item.productCount) }}</span>
            </template>

            <template #item.actions="{ item }">
              <div>
                <v-btn
                  :to="`/my-office/department/${item.id}`"
                  class="new_style"
                >
                  <vue-icon icon="newEyeIcon"></vue-icon>
                </v-btn>

                <v-btn
                  v-if="permissionsDepartment.DEPARTMENT_UPDATE"
                  @click="departmentUpdate(item)"
                  class="new_style"
                >
                  <vue-icon icon="newPencilIcon"></vue-icon>
                </v-btn>
                <v-btn
                  v-if="permissionsDepartment.DEPARTMENT_DELETE"
                  class="new_style"
                  @click="$refs.deleteDepartmentConfirmDialogRef.open(item)"
                >
                  <vue-icon icon="newTrashIcon"></vue-icon>
                </v-btn>
              </div>
            </template>
          </table-with-filter>
          <VuePagination
            go-to
            @update:limit="
              (limit) => {
                configurationDepartment.limit = limit;
                configurationDepartment.page = 1;
                changePageDepartment();
              }
            "
            v-model="configurationDepartment.page"
            :length="lastPageDepartment"
            @input="changePageDepartment"
            :limit="configurationDepartment.limit"
          />
        </div>
      </div>
      <div class="table-container" v-if="activeTab === 2">
        <div>
          <table-with-filter
            style="width: 100%"
            :is-filterable="false"
            fixed-header
            :height="$vuetify.breakpoint.height - 160"
            hide-default-footer
            :headers="headerEmployee"
            :items="employeeItems"
          >
            <template #item.createdAt="{ item }">
              <span>{{ fullTimeParse(item.createdAt) }}</span>
            </template>

            <template #item.actions="{ item }">
              <div>
                <v-btn :to="`/my-office/employee/${item.id}`" class="new_style">
                  <vue-icon icon="newEyeIcon"></vue-icon>
                </v-btn>
              </div>
            </template>
          </table-with-filter>
          <VuePagination
            go-to
            @update:limit="
              (limit) => {
                configurationEmployee.limit = limit;
                configurationEmployee.page = 1;
                changePageEmployee();
              }
            "
            v-model="configurationEmployee.page"
            :length="lastPageEmployee"
            @input="changePageEmployee"
            :limit="configurationEmployee.limit"
          />
        </div>
      </div>
    </div>
    <warning-dialog
      v-model="isAnotherDialogWarning"
      @apply="deleteProductHandler"
      ref="deleteProductConfirmDialogRef"
    ></warning-dialog>
    <warning-dialog
      v-model="warningDialog"
      @apply="deleteDepartmenthandler"
      ref="deleteDepartmentConfirmDialogRef"
    ></warning-dialog>
    <v-dialog v-model="departmentUpdateDialog" max-width="400px">
      <div class="model_container">
        <span>
          <span class="title">{{ this.$t("addDepartment") }}</span>
          <div @click="closeModal">
            <vue-icon
              icon="newBoldCloseIcon"
              style="cursor: pointer"
            ></vue-icon>
          </div>
        </span>
        <ValidationObserver ref="departmentObserver">
          <form @submit.prevent="handleAddDepartment" style="width: 100%">
            <div class="modalForm">
              <label>
                {{ this.$t("departmentName") }} (Ру)
                <ValidationProvider
                  :name="`${$t('departmentName')} (Ру)`"
                  rules="required"
                  v-slot="{ errors }"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <input
                    v-model="departmentData.nameRu"
                    :class="{ errorInput: !!errors[0] }"
                  />
                  <span class="error-text">{{ errors[0] }}</span>
                </ValidationProvider>
              </label>
              <label>
                {{ this.$t("departmentName") }} (O’z)
                <ValidationProvider
                  :name="`${$t('departmentName')} (O'z)`"
                  rules="required"
                  v-slot="{ errors }"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <input
                    v-model="departmentData.nameUz"
                    :class="{ errorInput: !!errors[0] }"
                  />
                  <span class="error-text">{{ errors[0] }}</span>
                </ValidationProvider>
              </label>
              <label>
                {{ this.$t("departmentName") }} (Eng)
                <ValidationProvider
                  :name="`${$t('departmentName')} (Eng)`"
                  rules="required"
                  v-slot="{ errors }"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <input
                    v-model="departmentData.nameEn"
                    :class="{ errorInput: !!errors[0] }"
                  />
                  <span class="error-text">{{ errors[0] }}</span>
                </ValidationProvider>
              </label>
              <label>
                {{ this.$t("resPerson1") }}
                <ValidationProvider
                  rules="required"
                  :name="this.$t('category')"
                  v-slot="{ errors }"
                >
                  <vue-select
                    :class="{ errorSelect: !!errors[0] }"
                    ref="ProductSelectRef"
                    infinite
                    :name="$t('resPerson1')"
                    :placeholder="$t('resPerson1')"
                    @item-resolved="setUserList"
                    :get-item-promise="
                      ({ text, page }) =>
                        getUserList({ name: text, page, limit: 15 })
                    "
                    v-model="departmentData.leaderId"
                    :items="departmentUserList"
                    clearable
                    itemText="fullName"
                    class="user_input no-margin"
                    style="flex-grow: 1"
                  ></vue-select>
                </ValidationProvider>
              </label>
              <v-btn
                type="submit"
                style="text-transform: capitalize; font-weight: 400"
                color="primary"
                :loading="loading"
              >
                {{ this.$t("add") }}
              </v-btn>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import TableWithFilter from "../../../components/ui/table/TableWithFilter.vue";
import WarningDialog from "../../../components/ui/prompt/warning-dialog";
import VueSelect from "../../../components/ui/vue-select/VueSelect.vue";
import { fullTimeParse } from "../../../utils/pureFunctions";
import { makerPagination } from "@/utils/pureFunctions";
import VuePagination from "@/components/ui/vue-pagination/VuePagination.vue";

export default {
  components: { TableWithFilter, WarningDialog, VueSelect, VuePagination },
  data() {
    return {
      fullTimeParse,
      items: [],
      loading: false,
      permessions: {},
      departmentItems: [],
      employeeItems: [],
      departmentUserList: [],
      configurationDepartment: {
        page: 1,
        sortBy: "numb",
        sortDirection: false,
        limit: 10,
      },
      configurationEmployee: {
        page: 1,
        sortBy: "numb",
        sortDirection: false,
        limit: 10,
      },
      lastPage: 0,
      lastPageDepartment: 0,
      lastPageEmployee: 0,
      configuration: {
        page: 1,
        sortBy: "numb",
        sortDirection: false,
        limit: 10,
      },
      permissionsDepartment: {},
      warningDialog: false,
      isAnotherDialogWarning: false,
      departmentParams: {
        page: 1,
        limit: 10,
      },
      employeeParams: {
        page: 1,
        limit: 10,
      },
      departmentData: {
        id: "",
        nameRu: "",
        nameUz: "",
        nameEn: "",
        leaderId: null,
        depType: "DEPARTMENT",
        forOffice: true,
      },
      params: {
        page: 1,
        limit: 10,
        name: null,
        from: null,
        to: null,
        userId: null,
      },
      activeTab: 0,
      tabs: ["officeProducts", "storeTheOffice", "employees"],
      departmentUpdateDialog: false,
    };
  },
  methods: {
    async changePage(value) {
      await this.$router.replace({
        query: { ...this.configuration },
      });
      this.params.page = value;
      await this.getProductList();
    },
    async changePageDepartment(value) {
      await this.$router.replace({
        query: { ...this.configurationDepartment },
      });
      this.departmentParams.page = value;
      await this.getDepartmentList();
    },
    async changePageEmployee(value) {
      await this.$router.replace({
        query: { ...this.configurationEmployee },
      });

      this.employeeParams.page = value;
      await this.getEmployeeList();
    },
    departmentUpdate(department) {
      this.departmentData = department;
      this.departmentUpdateDialog = true;
    },
    setUserList(data) {
      this.departmentUserList = data;
    },
    openCreateDepartmentDialog() {
      this.departmentData = {
        id: "",
        nameRu: "",
        nameUz: "",
        nameEn: "",
        leaderId: null,
        depType: "DEPARTMENT",
        forOffice: true,
      };
      this.departmentUpdateDialog = true;
    },
    async deleteDepartmenthandler(item) {
      this.showLoading();
      try {
        await this.$http.delete(`deparments/delete/${item.id}`);
        await this.getDepartmentList();
      } catch (e) {
        this.$notify({
          text: e.response.data.error_message.title,
          type: "error",
        });
      } finally {
        this.clearLoading();
      }
    },
    async deleteProductHandler(item) {
      this.showLoading();
      try {
        await this.$http.delete(`office-product/delete/${item.id}`);
        await this.getProductList();
      } catch (e) {
        console.log(e);
      } finally {
        this.clearLoading();
      }
    },
    async changeTab(index) {
      this.activeTab = index;
      localStorage.setItem("atb", index);
    },
    async getProductList() {
      try {
        const { data } = await this.$http.get("office-product/list", {
          params: {
            ...this.params,
            page: --this.params.page,
            limit: this.params.limit,
          },
        });
        this.items = data.data;
        this.permessions = data.permissions;
        this.lastPage = makerPagination({
          total: data.total,
          limit: this.params.limit,
        }).lastPage;
      } catch (e) {
        console.log(e);
      }
    },
    async getDepartmentList() {
      try {
        const { data } = await this.$http.get("deparments", {
          params: {
            page: --this.departmentParams.page,
            limit: this.departmentParams.limit,
          },
        });
        this.departmentItems = data.data;
        this.permissionsDepartment = data.permissions;
        this.lastPageDepartment = makerPagination({
          total: data.total,
          limit: this.departmentParams.limit,
        }).lastPage;
      } catch (e) {
        console.log(e);
      }
    },
    async getEmployeeList() {
      try {
        const { data } = await this.$http.get("user/list-for-office", {
          params: {
            page: --this.employeeParams.page,
            limit: this.employeeParams.limit,
          },
        });

        this.employeeItems = data.data;
        this.lastPageEmployee = makerPagination({
          total: data.total,
          limit: this.employeeParams.limit,
        }).lastPage;
      } catch (e) {
        console.error(e);
      }
    },
    async createDepartment() {
      this.showLoading();
      try {
        await this.$http.post("deparments", {
          ...this.departmentData,
        });
        await this.getDepartmentList();
        this.closeModal();
      } catch (e) {
        this.$notify({
          text: e.response.data.error_message.title,
          type: "error",
        });
      } finally {
        this.clearLoading();
      }
    },
    departmentNameTranslater(department) {
      return department[`name_${this.$i18n.locale}`];
    },
    closeModal() {
      this.departmentUpdateDialog = false;
    },
    async getUserList(params) {
      try {
        const {
          data: { data },
        } = await this.$http.get(`user/list`, {
          params,
        });
        return {
          data,
        };
      } catch (e) {
        console.log(e);
      }
    },
    handleAddDepartment() {
      this.$refs.departmentObserver.validate().then(async (success) => {
        this.loading = true;
        if (success) {
          console.log("SUCCESS");
          await this.createDepartment();
          await this.getEmployeeList();
          this.$refs.departmentObserver.reset();
        }
        this.loading = false;
      });
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("name"),
          value: "name",
        },
        {
          text: this.$t("numberOfProductCount"),
          value: "totalCount",
        },
        {
          text: this.$t("remains"),
          value: "remains",
        },
        {
          text: this.$t("resPerson"),
          value: "ownerName",
        },
        {
          text: this.$t("invCode"),
          value: "generated",
        },
        {
          text: this.$t("type"),
          value: "type",
        },
        {
          text: this.$t("dataModified"),
          value: "createdAt",
        },
        {
          text: this.$t("action"),
          value: "actions",
        },
      ];
    },
    headerDepartment() {
      return [
        {
          text: this.$t("name"),
          value: "name",
        },
        {
          text: this.$t("totalNumberOfProducts"),
          value: "productCount",
        },
        {
          text: this.$t("resPerson1"),
          value: "leader",
        },
        {
          text: this.$t("dataModified"),
          value: "createdAt",
        },
        {
          text: this.$t("action"),
          value: "actions",
        },
      ];
    },
    headerEmployee() {
      return [
        {
          text: this.$t("fio"),
          value: "fullName",
        },
        {
          text: this.$t("department2"),
          value: `department_${this.$i18n.locale}`,
        },
        {
          text: this.$t("numberOfProducts"),
          value: "productCount",
        },
        {
          text: this.$t("dataModified"),
          value: "createdAt",
        },
        {
          text: this.$t("action"),
          value: "actions",
        },
      ];
    },
  },
  async created() {
    this.activeTab = localStorage.getItem("atb")
      ? Number(localStorage.getItem("atb"))
      : 0;
    await this.getProductList();
    await this.getDepartmentList();
    await this.getEmployeeList();
    const { data } = await this.getUserList({ text: null, page: 0, limit: 15 });
    this.departmentUserList = data;
  },
};
</script>

<style scoped lang="scss">
input,
textarea {
  background-color: #fafbfc;
  border-radius: 5px;
  border: 1px solid #dfe2e9;
  outline: none;
  padding: 6px;
}

.page-title {
  font-family: "Rubik", sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 21.33px;
  text-align: left;
}

.table-container {
  border: 1px solid #e3ebf3;
  background-color: #fff;
  padding: 24px;
}

.tab-switcher-container {
  display: flex;
  gap: 8px;

  .tab-switcher {
    background-color: #fafbfc;
    padding: 8px 12px;
    border-radius: 6px 6px 0 0;
    border: 1px solid #e3ebf3;
    border-bottom: none;
    cursor: pointer;

    &.active {
      background-color: #fff;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 3px;
        background-color: #fff;
        bottom: -2px;
        left: 0;
      }
    }
  }
}

.add_product_btn {
  background-color: #0096b2;
  color: #fff;
  padding: 8px 10px;
  border-radius: 6px;
}

.badge {
  border-radius: 6px;
  padding: 8px 10px;
  background-color: #e3e6eb;
  color: #647182;

  &.badgeSuccess {
    background-color: #a2f6a0;
    color: #178015;
  }
}

.model_container {
  background-color: #fff;
  padding: 24px;

  span {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .modalForm {
    display: flex;
    flex-direction: column;
    gap: 18px;
    margin-top: 20px;

    input {
      width: 100%;
    }
  }
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s;
}

.v-enter,
.v-leave {
  opacity: 0;
}

.errorSelect .vue-select__wrap .vue-select__input {
  border: 1px solid red !important;
}

.errorInput {
  border-color: red;
  -webkit-box-shadow: inset 3px 0px 63px -31px rgba(255, 0, 0, 0.355);
  -moz-box-shadow: inset 3px 0px 63px -31px rgba(255, 0, 0, 0.355);
  box-shadow: inset 3px 0px 63px -31px rgba(255, 0, 0, 0.355);
}

.error-text {
  height: 10px;
  font-size: 12px;
  color: red;
  font-family: "Rubik", sans-serif;
  margin-top: 5px;
}
</style>
